'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import round from 'lodash/round';
import { trackClickEvent } from '@/utils/site-track';
import { SimplifyCityType } from '@/types/city';
import { numberToUpper } from '@/utils/numbers';

const CityCard = (props: SimplifyCityType & { dataEleGroup?: string }) => {
  const {
    avg,
    pinyin,
    name,
    adjacent_cities,
    adjacent_cities_by_competitive_rate,
    market_share,
    dataEleGroup = 'card_城市',
  } = props;
  const router = useRouter();

  const url = `/${pinyin}/`;
  const dataEleId = `${pinyin}_${name}`;
  const currentCitySalary = adjacent_cities?.find(
    ({ current_city }) => current_city,
  );
  const currentCityJob = adjacent_cities_by_competitive_rate.find(
    ({ current_city }) => current_city,
  );

  return (
    <li
      className="rounded-lg border border-web-grey-750 shadow-4xl cursor-pointer overflow-hidden px-6 py-5 text-xs group hover:border-web-blue-500"
      data-observer-id={pinyin}
      data-ele-group={dataEleGroup}
      data-ele-id={dataEleId}
      onClick={(e) => {
        trackClickEvent(e);
        router.push(url);
      }}
    >
      <div className="flex justify-between items-center">
        <Link
          href={url}
          title={name}
          onClick={(e) => trackClickEvent(e, true)}
          className="font-semibold line-clamp-1 text-base group-hover:text-web-blue-500"
          data-ele-group={dataEleGroup}
          data-ele-id={`${dataEleId}_link`}
        >
          {`${name.replace('市', '')}招聘`}
        </Link>
        <span className="text-web-grey-575">{`${currentCityJob?.job_count || 0} 个在招职位`}</span>
      </div>
      <p className="mt-2 flex items-center">
        平均薪资&nbsp;
        <span className="text-web-blue-500 text-lg leading-6">
          ¥{round(avg || 0, -2)}
        </span>
        &nbsp;<span className="text-web-grey-550">/月</span>
      </p>
      <p className="my-2 text-web-grey-550">热招职位类别</p>
      <div className="flex flex-wrap gap-2">
        {market_share.slice(0, 3).map(({ name, id }, index) => (
          <span
            className="px-2 py-0.5 rounded bg-web-grey-100"
            key={id + index}
          >
            {name}
          </span>
        ))}
      </div>
      <p className="text-web-grey-600 mt-2 pt-2 border-t border-web-grey-100">
        {`城市平均月薪排名第${numberToUpper(currentCitySalary?.rank || 0)}`}
      </p>
    </li>
  );
};

export default CityCard;
